import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { BuRedesignMetricsResultDto, BusinessUnitStatisticsDto, ToolsService } from '../../services/tools.service';

interface SbuOption { code: string; name: string; }

@Component({
  selector: 'app-bu-redesign-metrics',
  standalone: true,
  imports: [CommonModule, FormsModule, SpinnerComponent, MatDialogModule],
  templateUrl: './bu-redesign-metrics.component.html',
  styleUrls: ['./bu-redesign-metrics.component.css']
})
export class BuRedesignMetricsComponent implements OnInit {
  // ── Filters ─────────────────────────────────────────────────────
  fromDate: string = '';
  toDate: string = '';
  selectedSbu: string = '';

  sbuOptions: SbuOption[] = [];

  // ── State ────────────────────────────────────────────────────────
  isLoading = false;
  result: BuRedesignMetricsResultDto | null = null;
  errorMessage: string | null = null;

  constructor(private toolsService: ToolsService, public dialogRef: MatDialogRef<BuRedesignMetricsComponent>) {}


  ngOnInit(): void {
    // Default: From = 1 month ago, To = today (mirrors WPF BuRedesignMetricsRequest)
    const today = new Date();
    const monthAgo = new Date();
    monthAgo.setMonth(monthAgo.getMonth() - 1);
    this.toDate = this.toIsoDate(today);
    this.fromDate = this.toIsoDate(monthAgo);

    // Load SBUs using the existing tools endpoint
    this.toolsService.getSbus().subscribe({
      next: (sbus) => {
        this.sbuOptions = [{ code: '', name: '<All>' }, ...sbus.map(s => ({ code: s.sbuCode, name: s.sbuName }))];
      },
      error: () => { this.sbuOptions = [{ code: '', name: '<All>' }]; }
    });
  }

  get canGenerate(): boolean {
    return !!this.fromDate && !!this.toDate && this.toDate >= this.fromDate;
  }

  generate(): void {
    if (!this.canGenerate) return;
    this.isLoading = true;
    this.result = null;
    this.errorMessage = null;

    this.toolsService.getReport(
      this.fromDate,
      this.toDate,
      this.selectedSbu || undefined
    ).subscribe({
      next: (data) => {
        this.result = data;
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.detail ?? err?.message ?? 'Failed to generate report.';
        this.isLoading = false;
      }
    });
  }

  private toIsoDate(d: Date): string {
    return d.toISOString().split('T')[0];
  }

  trackByBu(_: number, bu: BusinessUnitStatisticsDto): string { return bu.buName; }
}
